import * as React from 'react'
function SvgChevronRight(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M13.467 32.533a2.64 2.64 0 010-3.733l8.8-8.8-8.8-8.8A2.64 2.64 0 1117.2 7.467l9.705 9.705a4 4 0 010 5.656L17.2 32.533a2.64 2.64 0 01-3.733 0z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgChevronRight
